import HeadingStyle from './Heading.style';

export default function Heading({ children }) {
  return <HeadingStyle>{children}</HeadingStyle>;
}
